module.exports = __webpack_public_path__ + "static/media/column-image-shir.f1d8d79f.jpg";